var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Tipos de Spots","storeName":"Type_spots","labelAddNew":"Agregar","canAdd":true,"canEdit":true,"canDelete":true,"sortable":"","next-link":"/admin/size_spots","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/type_spots'
      },
      {
        text: 'Tipos de Spots',
        disabled: false,
        href: '#'
      }
    ]},scopedSlots:_vm._u([{key:"picture",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[(item.picture)?_c('v-list-item-avatar',[_c('img',{attrs:{"src":item.picture,"alt":""}})]):_vm._e()],1)],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }